import { useState } from "react";

export function useToggle(initialValue = false): [boolean, () => void] {
  const [state, setState] = useState(initialValue);
  const toggleValue = (): void => {
    setState(!state);
  };
  return [state, toggleValue];
}
